module.exports = __webpack_public_path__ + "img/kr.8141d1be.svg";